module.exports = __webpack_public_path__ + "img/_dsc8164.979bbc45.jpg";